import React from 'react';
import { Check, CheckCircle } from 'lucide-react';

type DeliveryStatus = 'sending' | 'sent' | 'delivered' | 'read';

interface MessageDeliveryStatusProps {
  status: DeliveryStatus;
  readBy?: string[];
  timestamp: Date;
}

const MessageDeliveryStatus: React.FC<MessageDeliveryStatusProps> = ({
  status,
  readBy,
  timestamp
}) => {
  const renderIcon = () => {
    switch (status) {
      case 'sending':
        return <div className="h-3 w-3 rounded-full bg-[var(--text-secondary)] animate-pulse" />;
      case 'sent':
        return <Check className="h-4 w-4 text-[var(--text-secondary)]" />;
      case 'delivered':
        return <Check className="h-4 w-4 text-[var(--accent-primary)]" />;
      case 'read':
        return <CheckCircle className="h-4 w-4 text-green-400" />;
    }
  };

  return (
    <div className="flex items-center gap-1 text-xs text-[var(--text-secondary)]">
      {renderIcon()}
      {status === 'read' && readBy && readBy.length > 0 && (
        <span>Read by {readBy.length}</span>
      )}
    </div>
  );
};

export default MessageDeliveryStatus; 